import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as Yup from 'yup';


import { format } from 'date-fns';
import {
    storePleitoVeiculo,
    updatePleitoVeiculo
} from '~/store/modules/pleitoveiculo/actions';


import * as S from './styles';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { t, parseDateString } from '~/helpers';
import { closeDialog } from '~/store/modules/dialog/actions';
import { Input, DateTime, InputText, Select, Autocomplete } from '~/components/Form';
import { SelectComplete } from '~/componentslocal';
import { isEmpty, isNull } from 'lodash';

export default function DetalheJustificativa({ create, data, close, ...props }) {

    const reference = useRef(null);
    const redux = useSelector((state) => state.pleitoveiculo);
    const [initials, setInitials] = useState(data)



    return (
        <>
            <S.FormWrapper ref={reference} initialData={initials} >
                <Input name="unid_nome" label="Unidade:" disabled />
                <Input name="prod_descricao" label="Produto:" disabled />

                <Input
                    name="coun_justificativa"
                    label="Justificativa:"
                    inputProps={{ maxLength: 500 }}
                    multiline
                    rows={5}
                    disabled
                />

            </S.FormWrapper>


        </>
    );
}

DetalheJustificativa.propTypes = {
    reference: PropTypes.objectOf(PropTypes.any).isRequired,
    create: PropTypes.bool.isRequired,
    data: PropTypes.objectOf(PropTypes.any),
};

DetalheJustificativa.defaultProps = {
    data: {},
};
